<div class="app-loading" [style.border-radius.px]="borderRadius">
  <div class="logo" [style.backgroundImage]="'url(' + (spinnerUrl$ | async) + ')'"></div>
</div>
